if (!customElements.get('caelene-bundles')) {
  customElements.define('caelene-bundles', class extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.cfg = JSON.parse(this.querySelector('[data-config]').textContent);
      this.preferredVariant = this.cfg.product.variants.find(v => String(v.id) === new URLSearchParams(location.search).get('variant')) || this.cfg.product.variants.find(v => v.available && v.options.includes('Beige')) || this.cfg.product.variants.find(v => v.available);
      const linkedProducts = new Map();
      try {
        for (const offer of this.cfg.offers) {
          for (const key of ['gift', 'extra']) {
            if (typeof offer[key] !== 'string' || !offer[key]) continue;
            const handle = offer[key];
            if (!linkedProducts.has(handle)) {
              const response = await fetch(window.Shopify.routes.root + 'products/' + encodeURIComponent(handle) + '.js');
              if (!response.ok) throw new Error('Product unavailable');
              const product = await response.json();
              if (!Array.isArray(product.variants) || !product.variants.length) throw new Error('Invalid product');
              linkedProducts.set(handle, product);
            }
            offer[key] = linkedProducts.get(handle);
          }
        }
      } catch {
        this.querySelector('[role="alert"]').textContent = this.cfg.unavailable;
        this.querySelector('[data-ui]').hidden = false;
        return;
      }
      this.list = this.querySelector('[data-offers]');
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) { this.initialized = false; return; }
      this.buttons = [...new Set([...this.form.querySelectorAll('[type="submit"]'), ...document.querySelectorAll('[type="submit"][form="'+this.form.getAttribute('id')+'"]')])];
      this.status = this.querySelector('[role="alert"]');
      this.money = n => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency', currency:this.cfg.currency}).format(n / 100);
      this.offers = [];
      this.cfg.offers.forEach((offer, index) => {
        if (!offer.enabled || (!['regular','percent_auto'].includes(offer.mode) && !offer.code.trim()) || (offer.gift && !offer.code.trim())) return;
        if (offer.mode !== 'regular' && (!Number.isFinite(offer.value) || offer.value < 0 || (['percent','percent_auto'].includes(offer.mode) && offer.value > 100))) return;
        if (offer.mode === 'paid_quantity' && (!Number.isInteger(offer.value) || offer.value < 1 || offer.value >= offer.quantity)) return;
        const products = Array.from({length:offer.quantity}, () => ({product:this.cfg.product,gift:false}));
        if (offer.extra) products.push({product:offer.extra,gift:false});
        if (offer.gift) products.push({product:offer.gift,gift:true});
        if (products.some(p => p.product.variants.length >= 250 || p.product.selling_plan_groups?.length)) return;
        const state = {offer, products, rows:[], index};
        const card = this.el('div','cb-card');
        const label = this.el('label','cb-choice');
        const radio = this.el('input');
        radio.type = 'radio'; radio.name = 'cb-' + this.id; radio.value = index;
        radio.id = this.id + '-offer-' + index;
        label.htmlFor = radio.id;
        const copy = this.el('span','cb-copy');
        copy.append(this.el('strong','',offer.title));
        if (offer.subtitle) copy.append(this.el('small','cb-pill',offer.subtitle));
        if (offer.savings) copy.append(this.el('small','cb-savings',offer.savings));
        const prices = this.el('span','cb-prices');
        state.price = this.el('strong'); state.compare = this.el('s'); state.unit = this.el('small');
        prices.append(state.price,state.compare,state.unit);
        label.append(radio,copy,prices);
        card.append(label);
        if (offer.badge) {
          const badge=this.el('span','cb-badge',offer.badge);
          badge.style.background=offer.badgeColor || this.cfg.accent;
          badge.style.setProperty('--cb-accent',offer.badgeColor || this.cfg.accent);
          badge.style.color=offer.badgeText || '#ffffff';
          card.append(badge);
        }
        state.details = this.el('div','cb-details');
        products.forEach((entry,i) => {
          const p = entry.product;
          const row = this.el('div',i < offer.quantity ? 'cb-row' : 'cb-row cb-row-extra');
          const heading = this.el('div','cb-row-heading');
          const img = this.el('img'); img.width=42; img.height=52; img.alt=p.title; img.loading='lazy'; img.hidden=true;
          const title = entry.gift ? this.cfg.giftLabel + ' · ' + p.title : (i < offer.quantity ? '#' + (i+1) : p.title);
          heading.append(this.el('span','',title)); row.append(heading);
          const rowState = {product:p,gift:entry.gift,selects:[],image:img,variant:p.id===this.cfg.product.id ? this.preferredVariant : p.variants.find(v=>v.available)};
          const controls = this.el('div','cb-controls');
          p.options.forEach((option,j) => {
            if (p.variants.length === 1 && p.variants[0].title === 'Default Title') return;
            const name=typeof option === 'string' ? option : option.name;
            const field = this.el('div','cb-field');
            const isColor = this.cfg.colorOption ? name.toLowerCase()===this.cfg.colorOption.toLowerCase() : /color|colour|farbe|kleur|cor$/i.test(name);
            const caption=this.el('span','cb-caption',name);field.append(caption);
            const select = this.el('select');
            select.setAttribute('aria-label',title+' — '+name);
            [...new Set(p.variants.map(v=>v.options[j]))].forEach(value => {
              const opt=this.el('option','',value);opt.value=value;select.append(opt);
            });
            select.value=rowState.variant?.options[j] || p.variants[0].options[j];
            select.addEventListener('change',()=>this.refresh(state));
            rowState.selects.push(select);
            if(isColor){
              select.hidden=true;
              const menu=this.el('details','cb-color');
              const summary=this.el('summary','cb-color-current');
              summary.setAttribute('aria-label',title+' — '+name);
              const currentText=this.el('span');
              summary.append(img,currentText,this.el('span','cb-chevron','⌄'));
              const options=this.el('div','cb-color-options');
              [...new Set(p.variants.map(v=>v.options[j]))].forEach(value=>{
                const choice=this.el('button','cb-color-option');choice.type='button';choice.setAttribute('aria-label',name+': '+value);
                const picture=this.el('img');picture.width=38;picture.height=46;picture.alt='';picture.loading='lazy';
                const v=p.variants.find(v=>v.options[j]===value && v.featured_image) || p.variants.find(v=>v.options[j]===value);
                const src=v?.featured_image?.src || p.featured_image;
                if(src)picture.src=src;else picture.hidden=true;
                choice.append(picture,this.el('span','',value));
                choice.addEventListener('click',()=>{select.value=value;menu.open=false;this.refresh(state);summary.focus();});
                options.append(choice);
              });
              menu.append(summary,options);
              menu.addEventListener('keydown',e=>{if(e.key==='Escape'){menu.open=false;summary.focus();}});
              rowState.color={text:currentText,select,menu,options};
              field.append(menu);
            }
            field.append(select);controls.append(field);
          });
          row.append(controls);
          rowState.error = this.el('small','cb-unavailable'); row.append(rowState.error);
          state.rows.push(rowState);
          if (entry.gift) {
            row.className = 'cb-gift';
            card.classList.add('cb-has-gift');
            heading.className = 'cb-gift-heading';
            const giftCopy = this.el('span','cb-gift-copy');
            giftCopy.append(this.el('strong','cb-gift-label','+ ' + this.cfg.giftLabel));
            giftCopy.append(this.el('span','cb-gift-title',p.title.replace(/^Caelene\s*\|\s*/i,'')));
            heading.replaceChildren(img,giftCopy);
            rowState.giftPrice = this.el('s','cb-gift-price');
            heading.append(rowState.giftPrice);
            controls.hidden = p.variants.length === 1;
            state.giftRow = row;
          } else {
            state.details.append(row);
          }
        });
        state.radio=radio;state.card=card;
        radio.addEventListener('change',()=>this.select(state));
        card.append(state.details);
        if (state.giftRow) card.append(state.giftRow);
        this.list.append(card);this.offers.push(state);
        this.refresh(state);
      });
      if (!this.offers.length) {this.hidden=true;return;}
      this.select(this.offers.find(s=>s.index===this.cfg.defaultOffer-1) || this.offers[0]);
      this.dataset.ready='true';
      if(this.cfg.product.id===15437525156160)this.syncGallery(this.active.rows[0]);
      this.querySelector('[data-ui]').hidden=false;
    }
    el(tag, cls='', text) {
      const e=document.createElement(tag); if(cls)e.className=cls;if(text!==undefined)e.textContent=text;return e;
    }
    refresh(state) {
      let base=0, compare=0;
      state.valid=true;
      state.rows.forEach(row=>{
        row.variant = row.selects.length ? row.product.variants.find(v=>v.options.every((value,i)=>value===row.selects[i].value)) : row.product.variants[0];
        const v=row.variant;
        row.error.textContent=v?.available ? '' : this.cfg.unavailable;
        if (!v?.available) state.valid=false;
        const src=v?.featured_image?.src || row.product.featured_image;
        if(src){row.image.src=src;row.image.hidden=false;}
        if (row.giftPrice) { row.giftPrice.textContent = this.money(v?.price || 0); row.giftPrice.hidden = !v?.price; }
        if(row.color){
          row.color.text.textContent=row.color.select.value;
          [...row.color.options.children].forEach(b=>b.setAttribute('aria-pressed',String(b.textContent===row.color.select.value)));
        }
        if(v && !row.gift){base+=v.price;compare+=Math.max(v.price,v.compare_at_price||0);}
      });
      const o=state.offer;
      state.expected=o.mode==='paid_quantity' ? state.rows.filter(r=>!r.gift).map(r=>r.variant?.price||0).sort((a,b)=>b-a).slice(0,o.value).reduce((a,b)=>a+b,0) : ['percent','percent_auto'].includes(o.mode) ? state.rows.filter(r=>!r.gift).reduce((sum,r)=>sum+Math.round((r.variant?.price||0)*(1-o.value/100)),0) : o.mode==='amount' ? Math.max(0,base-Math.round(o.value*100)) : o.mode==='fixed' ? Math.round(o.value*100) : base;
      state.price.textContent=this.money(state.expected);
      state.compare.textContent=this.money(compare); state.compare.hidden=compare<=state.expected;
      const count=state.rows.filter(r=>!r.gift).length;
      state.unit.textContent=this.dataset.exactSets ? 'Gesamtpreis' : count>1 ? this.money(Math.round(state.expected/count))+' / '+this.cfg.unitLabel : '';
      if(this.dataset.exactSets)state.compare.hidden=true;
      if(this.active===state){this.syncForm();if(this.cfg.product.id===15437525156160)this.syncGallery(state.rows[0]);}
    }
    select(state) {
      this.active=state;
      this.offers.forEach(s=>{s.radio.checked=s===state;s.card.classList.toggle('is-selected',s===state);s.details.hidden=s!==state;});
      this.syncForm();this.status.textContent='';
      if(this.cfg.product.id===15437525156160)this.syncGallery(state.rows[0]);
    }
    syncForm() {
      this.buttons.forEach(b=>{
        b.disabled=!this.active.valid || !!this.busy || !!this.needsReview;
        if(this.dataset.exactSets){const label=b.querySelector('.btn-text');if(label)label.textContent='In den Warenkorb · '+this.money(this.active.expected);}
      });
      const input=this.form.querySelector('[name="id"]');
      if(input && this.active.rows[0].variant)input.value=this.active.rows[0].variant.id;
    }

    syncGallery(row) {
      const src=row?.variant?.featured_image?.src;
      if(!src || src===this.lastGallerySrc)return;
      this.lastGallerySrc=src;
      const gallery=this.closest('.shopify-section')?.querySelector('media-gallery');
      if(!gallery)return;
      const filename=src.split('?')[0].split('/').pop();
      const media=[...gallery.querySelectorAll('[data-media-id]')].find(el=>[...el.querySelectorAll('img')].some(img=>img.src.split('?')[0].split('/').pop()===filename));
      if(!media)return;
      const slider=gallery.sliderGallery;
      if(slider?.itemsToShow && typeof slider.select==='function'){
        const index=slider.itemsToShow.indexOf(media);
        if(index>=0)slider.select(index+1,true);
      }
      if(gallery.mediaPreview && media!==gallery.mediaPreview){
        const clone=media.cloneNode(true);clone.classList.remove('xl:hidden');
        gallery.mediaPreview.replaceWith(clone);
      }
    }
    async request(path, body) {
      const r=await fetch(window.Shopify.routes.root+path,{method:body?'POST':'GET',headers:body?{'Content-Type':'application/json'}:{},body:body?JSON.stringify(body):undefined});
      const data=await r.json();
      if(!r.ok)throw new Error(data.description||data.message||this.cfg.error);
      return data;
    }
    cartFromSections(sections) {
      for (const html of Object.values(sections || {})) {
        if (typeof html !== 'string') continue;
        try {
          const element=new DOMParser().parseFromString(html,'text/html').querySelector('[data-caelene-cart-state]');
          if (!element) continue;
          const cart=JSON.parse(element.textContent);
          if (Array.isArray(cart.items) && Number.isFinite(cart.item_count) && cart.items.every(item=>Number.isFinite(item.final_line_price) && Number.isFinite(item.quantity))) return cart;
        } catch {}
      }
      return null;
    }
    async add(event, form) {
      event.preventDefault();
      if(this.busy || this.needsReview || !this.active?.valid || !form.reportValidity())return;
      this.busy=true;this.syncForm();this.buttons.forEach(b=>b.setAttribute('aria-busy','true'));this.status.textContent=this.cfg.loading;
      let added=false;
      const s=this.active, group=crypto.randomUUID();
      try {
        const sections=[];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections',{bubbles:true,detail:{sections}}));
        const offerCodes=s.offer.code.split(',').map(c=>c.trim()).filter(Boolean);
        const before=offerCodes.length || this.dataset.exactSets ? await this.request('cart.js') : null;
        if(this.dataset.exactSets && before.items.some(item=>String(item.product_id)===String(this.cfg.product.id))) {
          this.status.textContent='Dieser Artikel liegt bereits im Warenkorb. Bitte prüfe dein Set dort. Für eine andere Set-Auswahl entferne zuerst die vorhandenen Artikel.';
          this.showCartLink();
          return;
        }
        const properties={};
        for(const [key,value] of new FormData(form)){const match=key.match(/^properties\[(.+)\]$/);if(match && typeof value==='string')properties[match[1]]=value;}
        const items=s.rows.map(row=>({id:row.variant.id,quantity:1,properties:{...properties,_caelene_bundle:group,_caelene_offer:s.offer.title,_caelene_gift:row.gift?'true':'false'}}));
        let response=await this.request('cart/add.js',{items,sections:sections.slice(0,5),sections_url:window.location.pathname});added=true;
        let cart;
        if(offerCodes.length) {
          const codes=[...new Set([...(before.discount_codes||[]).map(c=>c.code),...offerCodes])];
          response=await this.request('cart/update.js',{discount:codes.join(','),sections:sections.slice(0,5),sections_url:window.location.pathname});
          cart=response;
        } else {
          cart=this.cartFromSections(response.sections);
        }
        if(!Array.isArray(cart?.items) || !Number.isFinite(cart?.item_count))cart=await this.request('cart.js');
        const lines=cart.items.filter(i=>i.properties?._caelene_bundle===group);
        const quantity=lines.reduce((n,i)=>n+i.quantity,0);
        const actual=lines.reduce((n,i)=>n+i.final_line_price,0);
        const giftsFree=lines.filter(i=>i.properties?._caelene_gift==='true').every(i=>i.final_line_price===0);
        if(quantity!==items.length || (this.dataset.exactSets ? actual!==s.expected : actual>s.expected+items.length) || !giftsFree){
          this.status.textContent=this.cfg.mismatch;
          this.needsReview=true;this.showCartLink();
        } else {
          cart.sections=response.sections;
          if(window.theme?.pubsub)theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate,{cart});
          document.dispatchEvent(new CustomEvent('ajaxProduct:added',{detail:{product:response}}));
          this.status.textContent='';
          const drawer=document.querySelector('cart-drawer');
          if(window.theme?.settings?.cartType!=='page' && drawer?.show)drawer.show(event.submitter || this.buttons[0]);
          else window.location.assign(window.Shopify.routes.root+'cart');
        }
      } catch(error) {
        this.status.textContent=added ? this.cfg.mismatch : error.message;
        if(added){this.needsReview=true;this.showCartLink();}
      } finally {
        this.busy=false;this.buttons.forEach(b=>b.removeAttribute('aria-busy'));this.syncForm();
      }
    }
    showCartLink() {
      if(this.querySelector('.cb-cart-link'))return;
      const a=this.el('a','cb-cart-link',this.cfg.cartLabel);a.href=window.Shopify.routes.root+'cart';this.status.after(a);
    }
  });
}


